import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import { TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import Button from "../../Helpers/Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import { useResubmitIRMutation } from "../../../Redux/service/IR/IR";
import { toast } from "react-toastify";
import Loader from "../../Helpers/Loader/Loader";
import AntDatePicker from "../../FormBuilderInputs/DatePicker";
import AntUpload from "../../FormBuilderInputs/Upload";

export default function InspectionRequestQAResubmit({ irId, onSuccess }) {
  const [submitData, setSubmitData] = useState([]);
  let { setReloadData } = useContext(popupcontext);
  const [ResubmitMutation, { isLoading }] = useResubmitIRMutation();

  const initialValues = {
    correction_notes: null,
    ready_date: null,
    attachments: null,
  };

  const addForm = useFormik({
    initialValues,
    onSubmit: async (val) => {
      try {
        // Get ready_date from submitData (DatePicker stores it there)
        const readyDateItem = submitData.find(
          (item) => item.key === "ready_date"
        );
        const readyDate = readyDateItem?.value || null;

        // Get attachments from submitData
        const attachmentsItem = submitData.find(
          (item) => item.key === "attachments"
        );
        const attachments = attachmentsItem?.value || null;

        // Prepare the submission data
        const submissionData = {
          correction_notes: val.correction_notes || null,
          ready_date: readyDate,
          attachments: attachments,
        };

        await ResubmitMutation({ id: irId, val: submissionData }).unwrap();
        setReloadData(true);
        if (onSuccess) {
          onSuccess();
        }
        toast.success(trans("IR Form Resubmitted Successfully"), {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
      } catch (error) {
        toast.error(`${error?.data?.message}`, {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    addForm.handleSubmit(e);
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  // Create a dummy item for the uploader field
  const uploaderItem = {
    key: "attachments",
    name: "Uploader",
    title: trans("Attachments"),
    required: { value: false },
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextAreaInput
        title={trans("Correction Notes")}
        rows={3}
        placeholder={trans("Enter your correction notes")}
        id="correction_notes"
        name="correction_notes"
        onChange={(e) => addForm.handleChange(e)}
        onBlur={(e) => addForm.handleBlur(e)}
        value={addForm.values.correction_notes || ""}
      />

      <div className="mb-3">
        <AntDatePicker
          item={{
            key: "ready_date",
            name: "DatePicker",
            title: trans("Ready Date"),
            required: { value: true },
          }}
          preview={false}
          disable={false}
          addData={addForm}
          submitData={submitData}
          setSubmitData={setSubmitData}
        />
      </div>

      <div className="mb-3">
        <AntUpload
          item={uploaderItem}
          readOnly={false}
          addData={addForm}
          submitData={submitData}
          setSubmitData={setSubmitData}
        />
      </div>

      <Button
        htmlType="submit"
        type="primary"
        text={trans("Resubmit")}
        className="mt-2"
      />
    </form>
  );
}
